// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
// import { getUserProfile } from '../../../redux/actions/login'
import { isPermissionExist, sortPortalPermissionByKey } from '../../../utils/helper'
import { getLoggedUserData } from '../../../utils/HelperEvent'

function VehicleAndPermit(props) {
    const {partnerDetails, vehicleCount, userDetails} = props
    const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [accessPermissions, setAccessPermissions] = useState('')
    const [vehicleAccessPermissions, setVehicleAccessPermissions] = useState('')

    
    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Main Menu')
        setAccessPermissions(getAccessPermissionData)
        const vehicleAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Account Menu')
        setVehicleAccessPermissions(vehicleAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    useEffect(() => {
        const user = props?.userData ?? getLoggedUserData()?.user
        setUserData(user)
    }, [props.userData])

    return (
        <div className="container mb-4 mt-5" id="profileSnap">
            <div className="card card-body mt-4 mt-sm-0 ">
                <div className="row  align-items-center">
                    <div className="col-12 col-sm mb-sm-0 mb-3">
                        <small className="fw-light fw-bold">Welcome Back </small>
                        <h3 className="fw-bold mb-0 text-primary">{userData?.name}</h3>
                    </div>
                    {(isPermissionExist(accessPermissions, 'Pass Purchase')) ? <div className="col-sm-auto col-5  text-center">
                        <div className="p-2 border h-00  "><span className="h4 fw-bold text-secondary">{(userData?.active_pass_count && userData?.active_pass_count != '') ? userData?.active_pass_count : (userDetails?.active_pass_count && userDetails?.active_pass_count != '') ? userDetails?.active_pass_count : 0}</span><br /><small>Pass Added</small>
                        </div>
                    </div> : null}
                    {(isPermissionExist(vehicleAccessPermissions, 'Vehicle Details')) ? <div className="col-sm-auto col-5  text-center">
                        <div className="p-2 border h-00  "><span className="h4 fw-bold text-secondary">{vehicleCount ? vehicleCount : (userData?.userVehicleCount && userData?.userVehicleCount != '') ? userData?.userVehicleCount : (userDetails?.vehicle_count && userDetails?.vehicle_count != '') ? userDetails?.vehicle_count : 0}</span><br /><small>Vehicle Added</small>
                        </div>
                    </div>: null}
                    {(isPermissionExist(accessPermissions, 'Permit Purchase')) ? <div className="col-sm-auto col-5  text-center">
                        <div className="p-2 border h-100  "><span className="h4 fw-bold text-secondary">{(userData?.active_permit_count && userData?.active_permit_count != '') ? userData?.active_permit_count : (userDetails?.active_permit_count && userDetails?.active_permit_count != '') ? userDetails?.active_permit_count : 0}</span><br /><small>Active Permit</small>
                        </div>
                    </div>: null}
                </div>
            </div>
        </div>
    )
}

VehicleAndPermit.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    userData: PropTypes.object,
    partner: PropTypes.string,
    partnerDetails: PropTypes.object,
    vehicleCount: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    userDetails: PropTypes.object,
}

VehicleAndPermit.defaulProps = {
    dispatch: noop,
    loader: false,
    userData: EMPTY_OBJECT,
    partner: undefined,
    partnerDetails: EMPTY_OBJECT,
    vehicleCount: 0,
    userDetails: EMPTY_OBJECT,
}

function mapStateToProps({ permitListReducer, login , PartnerReducer}) {
    return { 
        loader: permitListReducer?.loader, 
        userData: login?.userDetails,
        partnerDetails: PartnerReducer?.partnerDetails?.data }
}
export default connect(mapStateToProps)(VehicleAndPermit)
